import { forwardRef } from 'react'
import { observer } from 'mobx-react'
import { Block, Paragraph } from 'suomifi-ui-components'
import type { StepComponent } from 'todistukset-ui/src/vtj/components/order-wizard/OrderWizardStep.type'
import { FormContainer } from 'todistukset-ui/src/vtj/components/order-wizard/CommonFormComponents.sc'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import AetFinallyBackToLandingPage from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/AetFinallyBackToLandingPage'
import ReceiptDownload from 'todistukset-ui/src/vtj/components/order-wizard/ReceiptDownload.react'
import OrderCompleteHeading from 'todistukset-ui/src/vtj/components/order-wizard/OrderCompleteHeading.react'

const UaetOrderCompleteStep: StepComponent = observer(
  forwardRef(function UaetOrderCompleteStep({ titleId }, _ref) {
    return (
      <FormContainer>
        <Block variant="section">
          <OrderCompleteHeading
            titleId={titleId}
            headingTranslationKey="orderWizardOrderCompleteStepMainTitle"
          />
          <Paragraph>
            <LocalizedString stringKey="orderWizardUaetInstructionsStepDeliveryText" />
          </Paragraph>
        </Block>
        <ReceiptDownload />
        <AetFinallyBackToLandingPage descriptionStringKey="uaetFinallyBackToLandingPageDescription" />
      </FormContainer>
    )
  })
)

export default UaetOrderCompleteStep
